
import { GoogleGenAI } from "@google/genai";

const ai = new GoogleGenAI({ apiKey: import.meta.env.VITE_GOOGLE_API_KEY });

export async function getDopamineCommentary(score: number, combo: number, status: 'fever' | 'milestone' | 'gameover' | 'penalty') {
  try {
    const prompt = `You are a high-energy, world-class football commentator (like a Korean TV broadcaster) for a game called "Neon Pitch". 
    The player's current score is ${score} and combo is ${combo}. 
    Trigger event: ${status}.
    Keep it very short (max 8 words), explosive, and full of dopamine-inducing hype in Korean. 
    Use football terms like 'GOAL!', 'SUPER SAVE!', 'RED CARD!', etc. 
    Use emojis.`;

    const response = await ai.models.generateContent({
      model: import.meta.env.VITE_GEMINI_LITE_MODEL,
      contents: prompt,
      config: {
        thinkingConfig: { thinkingBudget: 0 }
      }
    });

    return response.text || "대단한 슛입니다! ⚽️";
  } catch (error) {
    console.error("Gemini Commentary Error:", error);
    return "고오오오오올!!! 🔥";
  }
}
